import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import React, { } from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import './styles.scss'

const ModalPublishedWATemplate = (props) => {
  const { isOpen, toggle, message = null } = props
  return (
    <ModalWrapper
      id={'modal-published-wa-template'}
      header=' '
      body={
        <div className='delegate-ok-wrapper'>
          {!message && <img className={`check-ok-image`} alt={'check'} src={getStaticImage(`/icons/orange-brand/icon-check-full.svg`)} />}
          {!message && <h1>{`${I18n.t('dashboard_thats-it')}`}</h1>}
          <legend>{message || `${I18n.t('whatsapp_template_send_to_review')}`}</legend>
          <Button primary value={`${I18n.t('dashboard_ok')}`} onClick={toggle} />
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
    />
  )
}

export default ModalPublishedWATemplate
